<div style="width:100%;margin:auto;text-align:center;padding:20px"> 
    <img src="{{skinPath}}/images/landing_logo.png" alt="landing logo" style="margin-top:30px;margin-bottom:30px;" />
    <h1>Application Error</h1>
    <h3>Sorry, we're having some trouble!</h3>
    <hr style="width:80%;margin-bottom:30px">
    <div style="margin:auto;border:1px solid gray;border-radius:8px;padding:20px;max-width:400px;">
        <h4><strong>Error Details: </strong></h4>
        <p>
        Error ID: {{errorId}}<br/>
        Message: {{errorMessage}}
        </p>
        <p>Please contact support by clicking the Support button below or call 833-264-4368.</p>
        <p>
            Try logging in as a different user?<br />
            <a tabindex="0" (click)="logout()"  role="button" style="cursor:pointer" class="text-primary font-weight-bold">click here</a> to logout
        </p>
    </div>
</div>
